/** Authored city geography, independent of visitor locale and brand. */
export const CITY_GUIDE_COUNTRIES = Object.freeze({
  london: "uk", cotswolds: "uk",
  paris: "fr", "cote-dazur": "fr",
  tuscany: "it", rome: "it",
});

// Country URL folders use ISO codes except the established UK alias.
// A real country without a marketplace (e.g. Austria) still has a valid
// historical city alias; an invented country code must never redirect.
const COUNTRIES = new Set(("AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UK UM US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW").toLowerCase().split(" "));

export function canonicalCityGuidePath(slug) {
  const country = CITY_GUIDE_COUNTRIES[slug];
  return country ? `/${country}/cities/${slug}` : null;
}

export function cityGuidePathDecision(pathname) {
  const match = String(pathname).match(/^\/(?:([a-z]{2})(?:\/([a-z]{2}))?\/)?cities\/([^/]+)\/?$/i);
  if (!match) return null;
  const [, country, language, rawSlug] = match;
  const slug = rawSlug.toLowerCase();
  const canonical = canonicalCityGuidePath(slug);
  if (!canonical || (country && !COUNTRIES.has(country.toLowerCase()))) {
    return { status: 404, canonical: null, slug };
  }
  // These six authored articles have no independently translated variants.
  // Do not manufacture cross-country or language hreflang clusters.
  if (language && !/^(?:en|fr|it|de|es|pt|da|sv|no|nl|fi|pl|sk|cs|bg)$/.test(language.toLowerCase())) {
    return { status: 404, canonical: null, slug };
  }
  return { status: pathname === canonical ? 200 : 301, canonical, slug };
}

export function canonicalCitySitemapPaths(country) {
  return Object.entries(CITY_GUIDE_COUNTRIES)
    .filter(([, owner]) => country === undefined || owner === country)
    .map(([slug]) => canonicalCityGuidePath(slug));
}
